module.exports = __webpack_public_path__ + "communication.svg?faf71c7b1723e546821482a38a0a258b";